import { render, staticRenderFns } from "./Boutique.vue?vue&type=template&id=4995e69c&"
import script from "./Boutique.vue?vue&type=script&lang=js&"
export * from "./Boutique.vue?vue&type=script&lang=js&"
import style0 from "./Boutique.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports